export interface TicketConfig {
    reserveEndpoint: string;
    createEndpoint: string;
    trackingRoute:   string;
    zimplerUrl:   string;
}

export const TICKET_CONFIG: Record<string, TicketConfig> = {
    quicktip: {
        reserveEndpoint: '/api/quicktips/reserve',
        createEndpoint: '/api/quicktips/create',
        trackingRoute:   '/quicktips/tracking',
        zimplerUrl:      'https://brazil.betstack.io/collection-TG?betcode={CODE}&amount={AMOUNT}',
    },
    quickbet: {
        reserveEndpoint: '/api/quickbets/reserve',
        createEndpoint:  '/api/quickbets/create',
        trackingRoute:   '/quickbet/tracking',
        zimplerUrl:      'https://brazil.betstack.io/collection-TG?betcode={CODE}&amount={AMOUNT}',
    },
    smartbet: {
        reserveEndpoint: '/api/smartbets/reserve',
        createEndpoint:  '/api/smartbets/create',
        trackingRoute:   '/smartbet/tracking',
        zimplerUrl:      'https://brazil.betstack.io/collection-TG?betcode={CODE}&amount={AMOUNT}',
    },
    superbet: {
        reserveEndpoint: '/api/superbets/reserve',
        createEndpoint:  '/api/superbets/create',
        trackingRoute:   '/superbet/tracking',
        zimplerUrl:      'https://brazil.betstack.io/collection-TG?betcode={CODE}&amount={AMOUNT}',
    },
    quickbetx: {
        reserveEndpoint: '/api/quickbetxs/reserve',
        createEndpoint:  '/api/quickbetxs/create',
        trackingRoute:   '/quickbetx/tracking',
        zimplerUrl:      'https://brazil.betstack.io/collection-TG?betcode={CODE}&amount={AMOUNT}',
    },
    jackpot: {
        reserveEndpoint: '/api/jackpots/reserve',
        createEndpoint:  '/api/jackpots/create',
        trackingRoute:   '/jackpots/tracking',
        zimplerUrl:      'https://brazil.betstack.io/collection-TG?betcode={CODE}&amount={AMOUNT}',
    }
};

export const DEFAULT_TICKET_CONFIG: TicketConfig = TICKET_CONFIG['quicktip'];